module.exports = __webpack_public_path__ + "img/mtitle@2x.cafa924b.png";